export default __webpack_public_path__ + "static/media/regpost.a4d4d50b.png";